import React, { useCallback } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import FormDate from "../../../../components/formFeild/FormDate";
import FormCheck from "../../../../components/formFeild/FormCheck";
import baseUrl from "../../../../api/baseUrl";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";

interface AddCategoryProps {
  closeModal: () => void;
}
interface FormData {
  categoryName: string;
  startDate: string;
  endDate: string;
}

const AllPaymentReport: React.FC<AddCategoryProps> = ({ closeModal }) => {
  const methods = useForm<FormData>();

  const onSubmit: SubmitHandler<FormData> = useCallback(
    async (data) => {
      try {
        const response = await baseUrl.get("client/payment/paymentReport", {
          responseType: "blob",
          params: {
            startDate: data.startDate,
            endDate: data.endDate,
          },
        });

        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = "payment-report.pdf";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },
    []
  );

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-2xl w-full max-w-md overflow-hidden border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-600 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-primary/10 dark:bg-primary/20 rounded-lg flex items-center justify-center">
              <DescriptionIcon className="text-primary" sx={{ fontSize: 14 }} />
            </div>
            <h2 className="text-xs font-bold text-slate-800 dark:text-slate-200">Payment Report</h2>
          </div>
          <button
            onClick={closeModal}
            className="w-6 h-6 rounded-md bg-slate-100 dark:bg-slate-600 hover:bg-slate-200 dark:hover:bg-slate-500 flex items-center justify-center text-slate-600 dark:text-slate-300 transition-colors"
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </button>
        </div>
        {/* Form */}
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)} className="p-3 space-y-2.5">
            <div className="grid grid-cols-2 gap-2.5">
              <FormDate label="From" name="startDate" />
              <FormDate label="To" name="endDate" />
            </div>
            <FormCheck label="Include Patient Details" name="categoryNamAe" />
            <button
              type="submit"
              className="w-full flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
            >
              <DownloadIcon sx={{ fontSize: 16 }} />
              Download as PDF
            </button>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AllPaymentReport;
